module.exports = __webpack_public_path__ + "videos/shixiao.703dc7b5.mp4";